import { Component, OnInit } from '@angular/core';

// Services
import { PresetSettingsService } from '@modules/preset/services/preset-settings.service';
import { UserService } from '@modules/users/services/user.service';

// Components
import { PresetSettingsBaseComponent } from '../preset-settings-base/preset-settings-base.component';

@Component({
  selector: 'app-preset-settings-editshare',
  templateUrl: './preset-settings-editshare.component.html',
  styleUrls: ['./preset-settings-editshare.component.less']
})
export class PresetSettingsEditshareComponent extends PresetSettingsBaseComponent implements OnInit {

  /**
   * Constructor
   */

  constructor(
    protected presetSettingsService: PresetSettingsService,
    userService: UserService
  ) {
    super(presetSettingsService, userService);
  }

  /**
   * Component lifecycle
   */

  ngOnInit(): void {
  }

}
